<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="userActions">
    <span class="relative">
        <img class="w-7 h-7 rounded-full">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M3 18H21V16H3V18ZM3 13H21V11H3V13ZM3 6V8H21V6H3Z" fill="black"/>
            </svg>
        <!-- <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon> -->
        <!-- <span
            class="absolute right-0 bottom-0 w-2 h-2 rounded-full"
            [ngClass]="{'mr-px mb-px': !showAvatar || !user.avatar,
                          'bg-green-500': user.status === 'online',
                          'bg-amber-500': user.status === 'away',
                          'bg-red-500': user.status === 'busy',
                          'bg-gray-400': user.status === 'not-visible'}"
        ></span> -->
    </span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu" class="px-4 lg:mt-10 mt-2 rounded-2xl z-9999">
    <!-- <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>Welcome</span>
            <span class="mt-1.5 text-md  font-bold">{{userName}}</span>
        </span>
    </button> -->
    <button mat-menu-item (click)="home()"  >
        <!-- <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon> -->
        <span class="text-xl font-bold">My Library</span>
    </button>
    <button mat-menu-item (click)="goToBooks()"  class="md:hidden " >
        <!-- <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon> -->
        <span class="text-xl">Recommended Reading</span>
    </button>
    <button mat-menu-item (click)="navUrl('profile')">
        <!-- <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon> -->
        <span class="text-xl">My Profile</span>
    </button>
    <button mat-menu-item (click)="navUrl('devices')" >
        <!-- <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon> -->
        <span class="text-xl">Manage Devices</span>
    </button>
    <button mat-menu-item (click)="navUrl('manage-plan')" *ngIf="this.authService.userType === 'Individual'">
        <!-- <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon> -->
        <span class="text-xl">Manage My Plan</span>
    </button>
    <!-- "Refer a friend" is hidden here deliberately: the referral feature has no
         backend yet on the new API and is deferred to a future, dedicated build
         (product owner decision), showing a menu item for it would be an honest-
         looking link that does nothing. The route itself still resolves to an honest
         "coming soon" page for anyone who reaches it directly. -->
    <button mat-menu-item (click)="navUrl('give-a-gift')">
        <!-- <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon> -->
        <span class="text-xl">Give a gift</span>
    </button>
    <button mat-menu-item (click)="navUrl('faq')">
        <!-- <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon> -->
        <span class="text-xl">FAQ's</span>
    </button>
    <button mat-menu-item (click)="navUrl('contact')" >
        <!-- <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon> -->
        <span class="text-xl">Support</span>
    </button>
   
    <button mat-menu-item (click)="signOut()"  >
        <!-- <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon> -->
        <span class="text-xl font-bold">Logout</span>
    </button>
</mat-menu>

 